import styled from "styled-components";

export const GamePlayPcHeaderBarFreePlayIndicatorBox = styled.div<{isSelected: boolean}>`
    background-image: url("${props => props.isSelected ? props.theme.assets.images.game_frame.freeplay_indicator_selected_png.toString() : props.theme.assets.images.game_frame.freeplay_indicator_png.toString() }");
    background-repeat: no-repeat;
    background-size: contain;
    width: 45px;
    height: 45px;
    cursor: pointer;
`